import React from "react";
import BackgroundImage from "gatsby-background-image";
import { graphql, useStaticQuery } from "gatsby";

import * as classes from "./HeroImage.module.css";
import useWelsh from "../../useWelsh";

const HeroImage = () => {
  const welsh = useWelsh();
  const { solarpanels } = useStaticQuery(graphql`
    query {
      solarpanels: file(relativePath: { eq: "solarpanels.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <div className={classes.hero}>
      <div className={classes.padderLeft} />
      <div className={classes.text}>
        {welsh
          ? "Datblygiad Solar Newydd I Bweru Eich Cymuned"
          : "A New Solar Development To Power Your Community"}
      </div>
      <BackgroundImage
        className={classes.image}
        fluid={solarpanels.childImageSharp.fluid}
      />
    </div>
  );
};

export default HeroImage;
